import { useEffect } from "react";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import {
  WORKSPACE_MODE_REQUEST_EVENT,
  type WorkspaceModeRequestDetail,
} from "@/lib/workspaceModeNavigation";

/** In-content "open mode X" navigation from deep panels (e.g. Opp pricing → Service Quotes). */
export function useWorkspaceModeRequestListener(
  guardedSetMode: (mode: PrimaryMode) => void
) {
  useEffect(() => {
    function onRequest(ev: Event) {
      const detail = (ev as CustomEvent<WorkspaceModeRequestDetail>).detail;
      if (!detail?.mode) return;
      guardedSetMode(detail.mode);
    }
    window.addEventListener(WORKSPACE_MODE_REQUEST_EVENT, onRequest);
    return () => window.removeEventListener(WORKSPACE_MODE_REQUEST_EVENT, onRequest);
  }, [guardedSetMode]);
}
